import router from '@/modules/forgotPassword/router'
import ForgotPasswordApi from '@/modules/forgotPassword/service'
import { useForgotPasswordStore } from '@/modules/forgotPassword/store'

export default {
  router,
  service: new ForgotPasswordApi(),
  store: useForgotPasswordStore,
}
